import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetRfidBadgeOrdersPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.form-default-values';
import { GetRfidBadgeOrdersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterEmspBoRfidBadgeOrderListContextProvider,
  useEmspBoRfidBadgeOrderListContext,
} from '../emsp-bo-rfid-badge-order.context';
import { EmspBoRfidBadgeOrderListFilterFormController } from './emsp-bo-rfid-badge-order-list-filter-form/emsp-bo-rfid-badge-order-list-filter-form.controller';

interface EmspBoRfidBadgeOrderListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoRfidBadgeOrderListFilterController = ({
  onCancel,
  onSuccess,
}: EmspBoRfidBadgeOrderListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoRfidBadgeOrderListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetRfidBadgeOrdersPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-rfid-badge-order-list-filter.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetRfidBadgeOrdersPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      status: fieldValues.status,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetRfidBadgeOrdersPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterEmspBoRfidBadgeOrderListContextProvider data={data}>
      <EmspBoRfidBadgeOrderListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterEmspBoRfidBadgeOrderListContextProvider>
  );
};
